export default "/icon-upgrade-star.svg";